import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Lock, ShieldCheck, Download } from 'lucide-react';
export function ClosingSection() {
  const checkoutUrl = 'https://myschoolofbusiness.com/cart/47422073733314:1';
  return <section className="py-24 px-4 bg-text-primary text-white text-center relative overflow-hidden pb-32 sm:pb-24" data-id="element-15">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_bottom,_var(--tw-gradient-stops))] from-accent via-transparent to-transparent" data-id="element-16"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-17">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold mb-8 leading-tight" data-id="element-18">
          Puedes seguir esperando a que tu cuerpo "vuelva a la normalidad"…{' '}
          <br className="hidden sm:block" data-id="element-19" />
          <span className="text-accent" data-id="element-20">
            o puedes empezar hoy a entenderlo y apoyarlo mejor.
          </span>
        </motion.h2>

        <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto" data-id="element-21">
          Por solo $6.36, obtienes el mapa exacto para reducir la inflamación,
          recuperar tu energía y volver a sentirte cómoda en tu propia piel.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-22">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-10 py-6 bg-accent hover:bg-accent-dark text-white rounded-2xl font-black text-xl sm:text-2xl shadow-[0_10px_30px_rgba(212,163,115,0.4)] hover:shadow-[0_15px_40px_rgba(188,108,37,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 animate-pulse-slow" data-id="element-23">
            SÍ, QUIERO MI COPIA DE PERI-MENOPAUSIA REBELDE
            <Zap size={28} className="fill-current" data-id="element-24" />
          </a>

          <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-white/60 uppercase tracking-wider mt-4" data-id="element-25">
            <span className="flex items-center gap-2" data-id="element-26">
              <Lock size={18} data-id="element-27" /> Pago Seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-28">
              <Download size={18} data-id="element-29" /> Acceso Inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-30">
              <ShieldCheck size={18} data-id="element-31" /> Garantía 30 Días
            </span>
          </div>
        </div>
      </div>
    </section>;
}